<template>
  <div :class="style.mobileContent">
    <LeftPart v-if="selectedQuestion === -1" />
    <QuestionLeftPart v-else />

    <RightSection
      v-if="selectedQuestion === -1"
      :isUpdateRef="isUpdateRef"
      @completeUpdateRef="$emit('completeUpdateRef')"
    />
  </div>
</template>

<script lang="ts">
import {defineAsyncComponent, defineComponent} from "vue";

import style from "./LandingPreviewFrame.module.scss";

import QuestionLeftPart from "@/page/quiz/editor/landingPage/components/questions/QuestionLeftPart.vue";

export default defineComponent({
  name: "LandingMobileContent",

  components: {
    LeftPart: defineAsyncComponent(
      () =>
        import(
          "@/page/quiz/editor/landingPage/components/sections/LeftPart/LeftPart.vue"
        )
    ),

    QuestionLeftPart,

    RightSection: defineAsyncComponent(
      () =>
        import(
          "@/page/quiz/editor/landingPage/components/sections/RightSection/RightSection.vue"
        )
    )
  },

  props: {
    isUpdateRef: {
      type: Boolean,
      required: true
    }
  },

  emits: {
    completeUpdateRef: () => true
  },

  data() {
    return {
      style
    };
  },

  computed: {
    selectedQuestion(): number {
      return this.$quizStore.getSelectedQuestion;
    }
  }
});
</script>
